const AddIcon = () => {
    return <img src={process.env.PUBLIC_URL + '/style/img/btn-icon/ico-add2.png'} />;
};

export default AddIcon;
